import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export function useLoad(url, params) {
  const [data, setData] = useState(null);
  const key = JSON.stringify(params || {});
  const reload = useCallback(() => {
    api.get(url, { params: JSON.parse(key) }).then((r) => setData(r.data)).catch((e) => { toast.error(errMsg(e)); setData((d) => d ?? []); });
  }, [url, key]);
  useEffect(() => { reload(); }, [reload]);
  return { data, reload, setData };
}

export async function act(fn, ok) {
  try {
    const r = await fn();
    if (ok) toast.success(ok);
    return r?.data ?? true;
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}

export const PageHead = ({ title, desc, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
    <div><h1 className="text-3xl sm:text-4xl text-[#1B3B2B] tracking-tight" data-testid="admin-page-title">{title}</h1>{desc && <p className="text-sm text-stone-500 mt-1">{desc}</p>}</div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Stat = ({ label, value, testid, tone = "" }) => (
  <div className="bg-white border border-[#E8E0D5] rounded-2xl p-4" data-testid={testid}>
    <p className="text-[11px] uppercase tracking-[0.14em] text-stone-500">{label}</p>
    <p className={`text-2xl font-semibold mt-1 ${tone || "text-[#1B3B2B]"}`}>{value}</p>
  </div>
);

const LEAD = { HOT: "bg-rose-100 text-rose-700", WARM: "bg-amber-100 text-amber-700", COLD: "bg-blue-100 text-blue-700" };
export const LeadTag = ({ value }) => <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${LEAD[value] || "bg-stone-100"}`} data-testid="lead-category-tag">{value}</span>;

const PILL = { published: "bg-emerald-100 text-emerald-800", draft: "bg-stone-200 text-stone-700", archived: "bg-stone-100 text-stone-400", paid: "bg-emerald-100 text-emerald-800", pending: "bg-amber-100 text-amber-800", failed: "bg-rose-100 text-rose-700", refunded: "bg-blue-100 text-blue-700", Delivered: "bg-emerald-100 text-emerald-800", Cancelled: "bg-rose-100 text-rose-700", Pending: "bg-amber-100 text-amber-800", Converted: "bg-emerald-100 text-emerald-800", Lost: "bg-stone-200 text-stone-600", New: "bg-blue-100 text-blue-700" };
export const Pill = ({ value }) => <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${PILL[value] || "bg-[#E2EBE2] text-[#1B3B2B]"}`}>{value}</span>;

export const Field = ({ label, hint, children, className = "" }) => (
  <label className={`block space-y-1 ${className}`}><span className="text-xs font-medium text-stone-600">{label}</span>{children}{hint && <span className="block text-[11px] text-stone-400">{hint}</span>}</label>
);

export const inp = "w-full border border-[#E8E0D5] rounded-lg px-3 py-2 text-sm bg-white outline-none focus:border-[#6B8E78]";
export const btn = "inline-flex items-center justify-center gap-1.5 rounded-full bg-[#1B3B2B] text-[#FBF8F3] px-4 py-2 text-sm hover:bg-[#2C523A] transition-colors disabled:opacity-50";
export const btn2 = "inline-flex items-center justify-center gap-1.5 rounded-full border border-[#E8E0D5] bg-white px-4 py-2 text-sm hover:bg-[#F4EFE6] transition-colors";
export const card = "bg-white border border-[#E8E0D5] rounded-2xl p-4 sm:p-5";

export const confirmDo = (msg, fn) => { if (window.confirm(msg)) fn(); };

export function downloadCsv(path, filename) {
  api.get(path, { responseType: "blob" }).then((r) => {
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }).catch((e) => toast.error(errMsg(e)));
}
